var TileShapes;
(function (TileShapes) {
    TileShapes["square1x"] = "square1x";
    TileShapes["square2x"] = "square2x";
    TileShapes["rectangle2x1"] = "rectangle2x1";
    TileShapes["rectangle4x2"] = "rectangle4x2";
})(TileShapes || (TileShapes = {}));
export default TileShapes;
